'use client';

import { c as _c } from "react/compiler-runtime";
import { useFastNavigation } from '@/hooks/useFastNavigation';
interface FastNavLinkProps {
  href: string;
  onBeforeNavigate?: () => void;
  className?: string;
  children: React.ReactNode;
}
export const FastNavLink = t0 => {
  const $ = _c(6);
  const {
    href,
    onBeforeNavigate,
    className,
    children
  } = t0;
  let t1;
  if ($[0] !== onBeforeNavigate) {
    t1 = {
      onBeforeNavigate
    };
    $[0] = onBeforeNavigate;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const nav = useFastNavigation(href, t1);
  let t2;
  if ($[2] !== children || $[3] !== className || $[4] !== nav) {
    t2 = <a {...nav} className={className}>{children}</a>;
    $[2] = children;
    $[3] = className;
    $[4] = nav;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};